<template>
  <div class="edit-role">
    <div class="modal edit-role-modal" style="position: absolute !important">
      <div class="modal-background" @click="closeModal" />
      <button class="modal-close is-large" @click="closeModal" />
      <div class="modal-card">
        <section class="modal-card-body">
          <ChangeDriverRole
            v-if="showChangeDriver"
            :role="role"
            @close="showChangeDriver = false"
            @changed="
              infoToast('Changed driver role!');
              closeModal();
            "
          />

          <p v-if="role && !showChangeDriver" class="header is-size-4">
            <span
              v-if="$store.getters.isSuperUser"
              class="button is-rounded is-grey is-outlined is-pulled-right"
              style="padding: 9px"
              @click="showChangeDriver = !showChangeDriver"
            >
              <i class="fa fa-pencil-alt has-text-success" />
            </span>
            {{ role.business.name }}
            <br />
            {{ role.workflow_name }} - {{ role.role_name }}
            <!-- {{ roleTitle }} -->
          </p>
          <div class="card" style="border-radius: 25px">
            <div class="card-content">
              <div class="content has-text-left">
                <p class="field-name">
                  <span>{{ $t("profile.vehicle") }}</span>
                  <span class="is-pulled-right">{{ $t("profile.color") }}</span>
                </p>
                <i class="fa fa-shuttle-van"></i>&nbsp;&nbsp;
                <span class="tag is-dark is-medium" @click="editLicensePlate">{{
                  vehicleNumberFallback
                }}</span>
                <span class="is-pulled-right">
                  <swatches
                    style="
                      display: inline-block;
                      border: 2px black solid;
                      border-radius: 35%;
                      height: 36px;
                    "
                    v-model="color"
                    max-height="200"
                    swatch-size="32"
                    :trigger-style="{ width: '32px', height: '32px' }"
                    popover-to="left"
                    @close="updateRole"
                  />
                </span>

                <input
                  type="file"
                  ref="file"
                  style="display: none"
                  accept="image/png,image/jpeg,image/jpg,image/bmp"
                  @change="setVehiclePicAWS($event)"
                />

                <div class="is-flex" style="margin-top: 10px">
                  <div style="flex: 1" />
                  <figure class="image is-128x128">
                    <p class="field-name">{{ $t("profile.vehicle-pic") }}</p>
                    <img :src="imageURLFallback" @click="$refs.file.click()" />
                  </figure>
                  <div style="flex: 1" />
                </div>
              </div>
            </div>
            <div class="is-flex" style="gap: 8px">
              <button
                v-if="isSuperUser()"
                class="button is-info is-rounded is-outlined"
                @click="editDriverData"
              >
                Edit
              </button>
              <button
                class="button is-link is-rounded"
                style="flex-grow: 1"
                @click="submit"
              >
                {{ $t("submit") }}
              </button>
              <button
                v-if="isSuperUser()"
                class="button is-danger is-rounded is-outlined"
                @click="removeWorkerRole()"
              >
                Delete
              </button>
            </div>
          </div>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
import EventBus from "../eventBus";
import Swatches from "vue-swatches";
import "vue-swatches/dist/vue-swatches.min.css"; // Import the styles too, globally
import imageCompression from "browser-image-compression";

import ChangeDriverRole from "@/components/ChangeDriverRole.vue";

export default {
  name: "EditRoleModal",
  components: { ChangeDriverRole, Swatches },
  data() {
    return {
      color: "#000000", //"#1CA085",
      vehicleNumber: "",
      imageURL: "",
      role: null,
      showChangeDriver: false,
    };
  },
  computed: {
    // roleTitle() {
    //   if (!this.role) return "Unknown role";
    //   if (!this.role.business) return "Unknown role";
    //   var r = this.role;
    //   return `${r.business.name} - ${r.workflow_name} - ${r.role_name}`;
    // },
    vehicleNumberFallback() {
      if (this.vehicleNumber === "" || !this.vehicleNumber) {
        return this.$t("click-here");
      }
      return this.vehicleNumber;
    },
    imageURLFallback() {
      if (this.imageURL === "" || !this.imageURL) {
        return "/img/transport/siilor.png"; // "../assets/transport_menu_siilor.png";
      }
      return this.imageURL;
    },
    // colorFallback() {
    //   if (this.color === "" || !this.color) return "#1CA085";
    //   return this.color;
    // }
  },
  mounted() {
    EventBus.$on("EDIT_ROLE_MODAL", (r) => this.updateData(r));
  },
  methods: {
    closeModal() {
      this.updateRoles(false);
      this.$el.querySelector(".modal").classList.remove("is-active");
    },
    submit() {
      EventBus.$emit("UPDATED_DRIVER_ROLE");
      this.closeModal();
    },
    changeDriverRole() {
      this.infoToast("Superuser - Change Driver Role!", "top");
    },
    updateData(r) {
      this.role = r;
      console.log("edit role", r);
      if (!this.role.data) return;
      this.color = this.role.data.vehicle_color;
      this.vehicleNumber = this.role.data.vehicle_number;
      this.imageURL = this.role.data.vehicle_pic_url;
      console.log("updateData triggered", this.role.data);
    },
    editLicensePlate() {
      this.$swal({
        title: this.$t("profile.enter-vehicle-number"),
        input: "text",
        inputPlaceholder: "สก357",
        showCancelButton: true,
        confirmButtonText: this.$t("save"),
        cancelButtonText: this.$t("cancel"),
        inputValidator: (val) => {
          if (!val) {
            return this.$t("profile.must-enter-vehicle-number"); //"You must enter your name!";
          }
          this.vehicleNumber = val;
          this.updateRole();
        },
      });
    },
    updateRole() {
      // should rename to saveRole to avoid confusion with updateRoles
      var data = {
        vehicle_number: this.vehicleNumber,
        vehicle_color: this.color,
        vehicle_pic_url: this.imageURL,
      };
      var payload = {
        id: this.role.id,
        data: data,
      };
      this.console("updateRole", data);
      var loader = this.loadingDots();
      this.$store
        .dispatch("updateRoleData", payload)
        .then((res) => {
          console.log("updateRoleData", res);
          this.updateRoles(false);
        })
        .catch((err) => console.error("updateRoleData", err))
        .finally(() => loader.hide());
    },
    editDriverData() {
      EventBus.$emit("ROLE_EDIT_JSON_MODAL", this.role);
    },
    deleteWorkerRole(r) {
      var loader = this.loadingDots();
      this.$store
        .dispatch("deleteRole", r.id) // should soft delete
        .then((res) => {
          this.console(res);
          this.$store.dispatch("getRoles", this.$store.state.user.id);
        })
        .catch((err) => console.error(err))
        .finally(() => {
          loader.hide();
          this.closeModal();
        });
    },
    removeWorkerRole() {
      if (this.$store.getters.isSuperUser) {
        var r = this.role;
        if (r.state === "working") {
          this.warningAlert("You must stop working before deleting your role!");
          return;
        }
        this.deleteWorkerRole(r); // only delete role automatically if superuser
        return;
      }
      this.$swal({
        html: `<strong>${r.business.name} - ${r.workflow_name} - ${r.role_name}</strong>
        <br><br>Role removal request submitted<br><br>Please wait for confirmation`,
        showConfirmButton: true,
        type: "success",
      });
      this.$store
        .dispatch("sendEmail", {
          role: JSON.stringify(r),
          business_name: r.business_name,
          workflow_name: r.workflow_name,
          role_name: r.role_name,
          role_id: r.id,
          user_id: this.$store.state.user.id,
          mobile: this.$store.getters.phoneNumber,
          name: this.$store.getters.realName,
          type: "business role removal request",
          app: import.meta.env.VITE_TITLE,
        })
        .then((res) => this.console(res))
        .catch((err) => console.error(err));
    },
    // setVehiclePic(e) {
    //   if (!e.target.files) return;
    //   if (e.target.files.length === 0) return;
    //   var originalFile = e.target.files[0];

    //   var loader = this.loadingDots();
    //   var options = {
    //     maxSizeMB: 0.3,
    //     maxWidthOrHeight: 400,
    //     useWebWorker: true,
    //   };
    //   imageCompression(originalFile, options)
    //     .then((compressedFile) => {
    //       var sizeKB = Math.round(compressedFile.size / 1024);
    //       this.console(`compressedFile size ${sizeKB} KB`); // smaller than maxSizeMB

    //       this.$store
    //         .dispatch("uploadImage", compressedFile)
    //         .then((res) => {
    //           this.imageURL = res.data.data.thumb.url;
    //           this.updateRole();
    //         })
    //         .catch((err) => this.apiError(err))
    //         .finally(() => loader.hide());
    //     })
    //     .catch((err) => this.console("imageCompression error", err));
    // },

    setVehiclePicAWS(e) {
      if (!e.target.files) return;
      if (e.target.files.length === 0) return;
      var originalFile = e.target.files[0];

      var loader = this.loadingDots();
      var options = {
        maxSizeMB: 0.3,
        maxWidthOrHeight: 400,
        useWebWorker: true,
      };
      imageCompression(originalFile, options)
        .then((compressedFile) => {
          var sizeKB = Math.round(compressedFile.size / 1024);
          this.console(`compressedFile size ${sizeKB} KB`); // smaller than maxSizeMB

          imageCompression
            .getDataUrlFromFile(compressedFile)
            .then((base64) => {
              var data = {
                name: this.$shortid.generate() + ".png",
                content: base64.replace(/^data:image\/[a-z]+;base64,/, ""),
                businessID: "users", //this.role.business_id,
                imageType: "profile", //"digital_menu"
              };
              this.$store
                .dispatch("uploadImageAWS", data)
                .then((res) => {
                  console.log("uploadImageAWS", res.data);

                  this.imageURL = res.data.compressed_image_url;
                  this.updateRole();
                  // var newProfilePic = res.data.compressed_image_url;
                  // this.$store
                  //   .dispatch("setProfilePic", newProfilePic)
                  //   .then(() => this.successToast("Success!"))
                  //   .catch((err) => this.apiError(err));
                })
                .catch((err) => this.apiError(err))
                .finally(() => loader.hide());
            })
            .catch((err) => this.console("imageData error", err));
        })
        .catch((err) => this.console("imageCompression error", err));
    },
  },
};
</script>

<style scoped>
.header {
  text-align: left;
  font-weight: 500;
  padding: 0 4px;
  opacity: 0.7;
  color: navy;
}

.field-name {
  margin-bottom: 0;
  line-height: 0pt;
  font-size: 0.8em;
  opacity: 0.6;
}

.card {
  margin-top: 10px;
}

.modal-card-body {
  padding: 10px;
  border-radius: 25px;
}

figure {
  margin: 10px;
}

img {
  padding: 3px;
  border: 1px solid grey;
  border-radius: 25px;
  object-fit: cover;
}
</style>
